/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Missing_DescInputs */

const vi_einvoice_credential_missing_desc = /** @type {(inputs: Einvoice_Credential_Missing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các thao tác hóa đơn điện tử chạy bằng tài khoản MISA của chính bạn. Vào Cài đặt → Hóa đơn để kết nối; các nút sẽ hiện ngay sau khi kiểm tra kết nối thành công.`)
};

/**

* @param {Einvoice_Credential_Missing_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_missing_desc = /** @type {((inputs?: Einvoice_Credential_Missing_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Missing_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_missing_desc(inputs)
});